import { createSlice } from "@reduxjs/toolkit";
import { txTypeApi } from "./txtype-api";
import { channelApi } from "./channel-api";

export const THEME_KEY = "NETT_PORTAL_KEY";

type SupportedCurrencies = "NGN" | "USD" | "EUR" | "GHC" | "CAD" | "GBP";
type CurrencyData = {
  label: string;
  value: SupportedCurrencies;
};

const defaultSupportedCurrencies: CurrencyData[] = [
  {
    label: "Naira",
    value: "NGN",
  },
  {
    label: "US Dollar",
    value: "USD",
  },
  {
    label: "Ghana Cedis",
    value: "GHC",
  },
  {
    label: "Pounds",
    value: "GBP",
  },
];

interface SystemSlice {
  msgToast: toastPayload | null;
  txTypes: TxType[];
  channels: Channel[];
  currencies: CurrencyData[];
}

const initialState: SystemSlice = {
  msgToast: null,
  txTypes: [],
  channels: [],
  currencies: defaultSupportedCurrencies,
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    pushToastMessage: (state, action) => {
      state.msgToast = action.payload;
    },

    setChannels: (state, action) => {
      state.channels = action.payload;
    },

    setTxTypes: (state, action) => {
      state.txTypes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      txTypeApi.endpoints.loadTxTypes.matchFulfilled,
      (state, { payload }: { payload: TxType[] }) => {
        state.txTypes = payload;
      }
    );
    builder.addMatcher(
      channelApi.endpoints.loadChannels.matchFulfilled,
      (state, { payload }: { payload: Channel[] }) => {
        state.channels = payload;
      }
    );
  },
});

export const systemActions = systemSlice.actions;
export default systemSlice.reducer;
